import { FC, useCallback } from 'react';
import { MdOpenInNew as OpenInNewIcon } from 'react-icons/md';
import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import { ConnectionInstructions } from '../types/connection-types';

const InstructionsButton: FC<
  React.PropsWithChildren<InstructionsButtonProps>
> = props => {
  const { instructions } = props;
  const { linkLabel, linkTooltip, link } = instructions;

  const onOpenInstructions = useCallback(() => {
    if (!link) {
      return null;
    }

    window.open(link, '_blank');
  }, [link]);

  return (
    <Box alignSelf='center'>
      <NoMaxWidthTooltip title={linkTooltip}>
        <Button
          onClick={onOpenInstructions}
          size='small'
          variant='text'
          color='primary'
          startIcon={<OpenInNewIcon fontSize='small' />}>
          <Typography>{linkLabel}</Typography>
        </Button>
      </NoMaxWidthTooltip>
    </Box>
  );
};

export interface InstructionsButtonProps {
  instructions: ConnectionInstructions;
}

const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip arrow {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

export default InstructionsButton;
